import React from 'react'

import { MediumWidgetsName } from '../types'
import { AvgWinnerLoser, TargetAccuracy, BiggestWinnerLoser, LongShort } from '../widgets'

export const useGetMediumWidgets = () => {
  return {
    [MediumWidgetsName.targetAccuracy]: <TargetAccuracy />,
    [MediumWidgetsName.avgWinnerLoser]: <AvgWinnerLoser />,
    [MediumWidgetsName.biggestWinnerLoser]: <BiggestWinnerLoser />,
    [MediumWidgetsName.longShort]: <LongShort />,
  }
}
